// extracted by css-extract-rspack-plugin
export default {"paper":"organisation-area-settings-popover_paper__hlppl"};